import { apiPost } from "./api";
import { StoreNotification } from "../types/notification";

export const markStoreNotificationAsRead = (notificationId: number) => {
    return apiPost<StoreNotification>(`store-notification/${notificationId}/read`);
};

export const markAllStoreNotificationsAsRead = () => {
    return apiPost<{ updatedCount: number }>("store-notification/read-all");
};
